import React from 'react'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Badge from '@material-ui/core/Badge'
import Card from '@material-ui/core/Card'
import Loading from '../../Container/Loading/Loading'
import withWidth from '@material-ui/core/withWidth'
import { compose } from 'recompose'
import _ from 'lodash'
import InboxItem from './InboxItem'
import InboxItemDetails from './InboxItemDetails'

const styles = theme =>({
    inboxPaper: {
        padding: theme.spacing.unit,
        paddingTop: theme.spacing.unit *3 + 'px!important',
        //width: '100%',
        [theme.breakpoints.down('sm')]: {
        padding: theme.spacing.unit,
        }
    },
    titleWrapper: {
        marginBottom: theme.spacing.unit,

    },
    header: {
        borderRadius: '8px 8px 0 0',
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        padding: theme.spacing.unit,
    },
    inboxBadge: {
        top: '-4px',
        right: '-24px'
    }
})

const MessagingInbox = (props) => {
    const { classes, inboxItems, inboxCounter, itemClickCallback, clickedMessageId, clickedArrIndex, clickedRequesterData, clickedEvent, functions } = props

    const isMobile = () => {
        return props.width === 'sm' || props.width === 'xs'
            ? true
            : false
    }
   
    const renderInboxHeader = (
        <Grid style={{marginBottom: '8px'}} item xs={12} md={12}>
                <Card className={classes.header}>
                    <Grid container alignItems='flex-start'>
                        <Grid item xs={12} md={3}>
                           <HeaderProp title='Erhalten' />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <HeaderProp title='Absender' />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <HeaderProp title='Betreff' />
                        </Grid>
                    </Grid>
                 </Card>
        </Grid>
    )

    const renderItemDetails = clickedMessageId!==null
        ?<InboxItemDetails 
            message={inboxItems[clickedArrIndex]}
            closeBtn={functions.closeBtnItemDetails}
            requesterData={clickedRequesterData}
            event={clickedEvent.event}
            functions={functions.itemDetails}
        />
        : null

    const renderInboxItems = (
        _.map(inboxItems, (message, index) =>
            <Grid style={{marginBottom: '8px'}} key={message.ids.messageId} item xs={12} md={12}>
               <div onClick={()=>itemClickCallback(message.ids.messageId, index)}>
                <InboxItem 
                        message={message}
                        isMobile={isMobile()}
                        clickedMessageId={clickedMessageId}
                    />
                </div>
                 {clickedMessageId===message.ids.messageId && isMobile()===true
                        ? renderItemDetails
                        : null}
            </Grid>
        )
    )   

    return (
        <Grid container spacing={8} alignItems='flex-start' >
            <Grid item xs={12} md={6} >
                <Paper className={classes.inboxPaper}>
                    <div className={classes.titleWrapper} >
                        <Badge classes={{ badge: classes.inboxBadge }} badgeContent={inboxCounter || 0} color={inboxCounter ? 'secondary' :'primary'} >
                            <Title title = {props.title} />     
                        </Badge>
                    </div>
                    <div>
                        {renderInboxHeader}
                        {!inboxItems
                            ? <Loading text='Nachrichten werden geladen...' />
                            : inboxItems.length===0 ? <span style={{padding: '8px', fontWeight: 'bold'}}>Keine Nachrichten vorhanden</span> : renderInboxItems
                        }
                    </div>
                </Paper>
                
            </Grid>
            <Grid item xs={12} md={6} >
                    {isMobile()===false
                        ? renderItemDetails
                        : null}
                
            </Grid>
        </Grid>
    )
}

const HeaderProp =  ({title, style}) => <Typography style={style || {}} variant='subheading' color='inherit' >{title}</Typography>
export const Title =  ({title, style}) => <Typography style={style || {}} variant='title' color='primary' >{title}</Typography>

export default compose(withWidth(), withStyles(styles))(MessagingInbox)


// WEBPACK FOOTER //
// ./src/Components/MessagingCenter/MessagingInbox.js